export default __webpack_public_path__ + "static/media/WHITTIER DISTRIC LOGO_outlined-04.15bb60a0.jpg";